import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import { formViews } from "../../common/AccountForm";
import ConnectedEventProfileImage from "../../common/EventProfileImage";
import "./AccountModalHeaderImage.scss";

const AccountModalHeaderImage = ({ formView }) => {
    // Set the default image to the event profile image
    let image = <ConnectedEventProfileImage />;

    // On the confirmation view that appears after the user clicks the "Need
    // help with password button" display the paper plane image instead of the
    // event profile image
    if (formView === formViews.SEND_RESET_PASSWORD_EMAIL_CONFIRMATION) {
        image = (
            <Icon
                className="account-modal-header-image__paper-plane-duotone -color--theme-primary"
                glyph="paper-plane-duotone"
                type="FontAwesome"
            />
        );
    }

    return (
        <div className="grid">
            <div className="col col--12">{image}</div>
        </div>
    );
};

AccountModalHeaderImage.propTypes = {
    formView: PropTypes.string.isRequired,
};

export default AccountModalHeaderImage;
